import styled, { keyframes, css } from 'styled-components'

import { Form } from '@/ui'

const show = () => keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);

  }
`
const hide = () => keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);

  }
`

export const AnimationContainer = styled.div`
  .animateIn {
    animation: ${show} forwards;
  }
  .animateIn.out {
    animation: ${hide} forwards;
  }
`
export const HideButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  border: 0;
  cursor: pointer;
  outline: 0;
  line-height: 1;
  font-size: 16px;
  &&& .icon {
    margin-right: 5px;
    cursor: pointer;
  }
`

export const SidebarContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  border-left: 1px solid #002e3e0d;
  width: 20vw;
  height: 100vh;
  z-index: 1000;
  background-color: #fff;
`

export const Section = styled.div`
  padding: 10px;
  border-bottom: 1px solid #002e3e0d;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ColumnList = styled.ul`
  &&& {
    list-style: none;
    padding: 0;
    li {
      line-height: 1;
      display: flex;
      font-size: 16px !important;
      justify-content: space-between;
      padding: 20px;
      margin: 0;
      cursor: pointer;
      border-bottom: 1px solid #002e3e0d;
      .field label {
        margin: 0 !important;
      }
      > span {
        font-size: 16px;
      }
      > div {
        align-items: center;
      }
      .checkbox {
        margin: 0;
      }
      .checked label {
        ::before {
          background-color: #0a5b8b;
        }
        ::after {
          color: #fff;
        }
      }
    }
  }
`
export const FilterContainer = styled.div<{ expanded?: boolean }>`
  ${({ expanded }) => css`
    &&&& {
      cursor: pointer;
      display: flex;
      align-items: center;
      i {
        cursor: pointer;
      }
      .icon-filter {
        font-size: 0.8em !important;
      }
      span {
        font-size: 16px;
      }
      svg {
        margin-left: 10px;

        transform: rotate(${expanded ? '90deg' : '0'});
        transition: transform 0.2s;
      }
    }
  `}
`

export const FilterCount = styled.span<{ triggerIcon?: boolean }>`
  ${({ triggerIcon }) => css`
    &&&&&& {
      position: ${triggerIcon ? 'absolute' : 'static'};
      background-color: #ff9186;
      margin-right: 5px;
      top: -10px;
      z-index: 5;
      right: -10px;
      font-size: 10px;
      color: #fff;
      padding: 5px 10px;
      line-height: 1;
      border-radius: 10px;
    }
  `}
`
//@ts-ignore
export const StyledForm = styled(Form)`
  height: 100vh;
  overflow: auto;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
`

export const Actions = styled.div`
  &&&&&& {
    padding: 20px;
    border-top: 1px solid #002e3e0d;
    div:last-child {
      text-align: right;
      button {
        color: #fff;
      }
    }
    .field {
      margin: 0;
    }
    button {
      font-weight: 400;
    }
    display: flex;
    justify-content: space-between;
  }
`

export const EditContainer = styled.li`
  background-color: #fafcfc;
  label {
    color: #4d6c78;
    font-size: 14px;
  }
`

export const SearchContainer = styled.div`
  padding: 10px;
  width: 100%;
  .search {
    min-width: 100%;
    max-width: 100%;
  }
`

export const ContentOverlay = styled.div`
  z-index: 100;
  width: 80vw;
  height: 100vh;
  position: absolute;
  left: -80vw;
`
